module.exports = __webpack_public_path__ + "static/media/Anna.966cdb26.jpg";